<template>
  <div class="space-y-2">
    <p>
      You can manage or delete cookies through your browser settings. However, disabling cookies will prevent you from logging in or accessing restricted areas of the site.
    </p>
    <p><strong>To manage local storage:</strong></p>
    <ul class="list-disc list-inside space-y-1">
      <li>Clear your browser cache or local storage manually.</li>
      <li>Resetting this data may remove saved preferences or settings.</li>
    </ul>
    <p>
      For more information on how to manage cookies, visit
      <a href="https://www.aboutcookies.org/" target="_blank" rel="noopener noreferrer" class="text-blue-600 dark:text-blue-400 underline">
        AboutCookies.org
      </a>.
    </p>
  </div>
</template>